const providerIdMapping = {
    UBER: 1,
    LYFT: 2,
    EXTERNAL:4
};
Object.freeze(providerIdMapping);
export default providerIdMapping;
